import VisualPlannerApi from "@/VisualPlannerApi";

export default {
  namespaced: true,
  state: {
    dayList: [],
    isLoading: false,
    requestStartDate: null,
    requestEndDate: null,
    roomIds: null,
    personIds: null,
    eventIds: null
  },

  mutations: {
    SET_DAY_LIST(state, days) {
      state.dayList = days;
    },
    ADD_DAY(state, day) {
      state.dayList.push(day);
    },
    SET_LOADING(state, loading) {
      state.isLoading = loading;
    },
    SET_REQUEST_START_DATE(state, date) {
      state.requestStartDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0, 0, 1, 0
      ));

    },
    SET_REQUEST_END_DATE(state, date) {
      state.requestEndDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23, 59, 59, 0
      ));
    },
    SET_ROOM_IDS(state, roomIds) {
      state.roomIds = roomIds;
    },
    SET_PERSON_IDS(state, personIds) {
      state.personIds = personIds;
    },
    SET_EVENT_IDS(state, eventIds) {
      state.eventIds = eventIds;
    }
  },

  actions: {
    setRequestStartDate({ commit }, startDate) {
      commit("SET_REQUEST_START_DATE", startDate);
    },

    setRequestEndDate({ commit }, endDate) {
      commit("SET_REQUEST_END_DATE", endDate);
    },
    setRoomIds({ commit }, roomIds) {
      commit("SET_ROOM_IDS", roomIds);
    },
    setPersonIds({ commit }, personIds) {
      commit("SET_PERSON_IDS", personIds);
    },
    setEventIds({ commit }, eventIds) {
      commit("SET_EVENT_IDS", eventIds);
    },

    async fetchDayList({ commit, state }, dayIntervalLocal) {
      commit("SET_LOADING", true);
      commit("SET_DAY_LIST", []);
      try {
        const response = await VisualPlannerApi.get("data", {
          params: {
            requestStartDate: state.requestStartDate.toISOString(),
            requestEndDate: state.requestEndDate.toISOString(),
            dayCount: dayIntervalLocal,
            ...((state.roomIds && state.roomIds.length > 0) && { roomIds: state.roomIds.join(",") }),
            ...((state.personIds && state.personIds.length > 0) && { personIds: state.personIds.join(",") }),
            ...((state.eventIds && state.eventIds.length > 0) && { subjectIds: state.eventIds.join(",") })
          }
        });

        response.data.forEach(day => {
          commit("ADD_DAY", day);
        });
      } catch (error) {
        console.error("Error fetching day list:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    }
  }
};
